import { InjectionToken } from '@angular/core';
import { Context, Span, SpanOptions } from '@opentelemetry/api';

/**
 * Narrow slice of `SpanService` (OpenTelemetry tracing) used by the auth effects that moved to
 * `platform/state` (DEV-26105 T6a — `change-email`, `login`). `SpanService` lives in
 * `shared/ui/core` (`_core/vendor/opentelemetry`) and pulls the whole otel vendor module, so it can't
 * move here without reopening the `platform/state -> shared/ui/core` edge. The effects inject this
 * token; the app composition root binds it via `{ provide: SPAN_CONTROL, useExisting: SpanService }`.
 * Same token-inversion mechanism as T5's `NOTIFY_CONTROL`/`USER_SERVICE`.
 */
export interface SpanControl {
  startSpan(
    spanName: string,
    options?: {
      attributes?: SpanOptions['attributes'];
      kind?: SpanOptions['kind'];
      parentSpan?: Span;
      traceContext?: Context;
    }
  ): Span;
  closeSpan(span: Span, error?: Error | string): void;
}

/** No-op default so the effects never null-inject in test/storybook. `closeSpan` ignores empty spans. */
export const SPAN_CONTROL = new InjectionToken<SpanControl>('SPAN_CONTROL', {
  providedIn: 'root',
  factory: (): SpanControl => ({
    startSpan: (): Span => undefined as unknown as Span,
    closeSpan: (): void => undefined,
  }),
});
